<!-- 网关账号管理 -->
<template>
  <div class='content'>
    <el-form ref="form" label-width="auto" align="left" :inline="true">
      <el-form-item label="网关账号：">
        <el-input placeholder="请输入网关账号" @change="getTableList()" v-model="params.netBarAccount"></el-input>
      </el-form-item>
      <el-form-item label="网关名称：">
        <el-input placeholder="请输入网关名称" @change="getTableList()" v-model="params.netBarName"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="getTableList()">搜索</el-button>
        <el-button size="small" @click="resetParams();getTableList();">重置</el-button>
      </el-form-item>
    </el-form>
    <div>
      <el-button size="small" type="primary" @click="resetForm();title='新增';dialogVisible=true">新增</el-button>
      <el-button size="small" type="primary" @click="formBatch.file='';dialogVisibleBatch=true">批量新增</el-button>
    </div>

    <el-table 
      :data="tableData"
      class="mt-20"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}">
      <!-- show-overflow-tooltip -->
      <el-table-column label="网关账号" prop="netBarAccount"></el-table-column>
      <el-table-column label="网关名称" prop="netBarName"></el-table-column>
      <el-table-column label="网关来源" prop="netBarSource"></el-table-column>
      <el-table-column label="马蹄ID" prop="matiBarAccount"></el-table-column>
      <el-table-column label="网吧公网ID" prop="barIp"></el-table-column>
      <el-table-column label="网吧mac" prop="barMac"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button 
            type="text" 
            size="small" 
            @click="update(scope.row)">编辑</el-button>
          <el-button 
            type="text" 
            size="small" 
            @click="deleteFun(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-row class="mt-15 mr-20 text-right" v-if="total > 0">
      <el-pagination 
        small layout="total,prev,pager, next,sizes,jumper" 
        :page-size="params.pageSize"
        :total="total" 
        :current-page.sync="params.pageNum" 
        :page-sizes="[10 ,20 , 30, 40, 50]"
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange">
      </el-pagination>
    </el-row>

    <!-- 新增/编辑 -->
    <el-dialog :title="title" top="20px" :visible.sync="dialogVisible"> 
      <el-form :model="form" ref="form" :rules="rules" label-width="auto">
        <el-form-item label="网关账号：" prop="netBarAccount">
          <el-input type="text" v-model="form.netBarAccount" placeholder="请输入网关账号"></el-input>
        </el-form-item>
        <el-form-item label="网关名称：" prop="netBarName">
          <el-input type="text" v-model="form.netBarName" placeholder="请输入网关名称"></el-input>
        </el-form-item>
        <el-form-item label="网关来源：" prop="netBarSource">
          <el-input type="text" v-model="form.netBarSource" placeholder="请输入网关来源"></el-input>
        </el-form-item>
        <el-form-item label="马蹄ID：" prop="">
          <el-input type="text" v-model="form.matiBarAccount" placeholder="请输入马蹄ID"></el-input>
        </el-form-item>
        <el-form-item label="网吧公网ID：" prop="">
          <el-input type="text" v-model="form.barIp" placeholder="请输入网吧公网ID"></el-input>
        </el-form-item>
        <el-form-item label="网吧mac：" prop="">
          <el-input type="text" v-model="form.barMac" placeholder="请输入网吧mac"></el-input>
        </el-form-item>
      </el-form>
      <el-row class="text-right mt-20">
        <el-button @click="resetForm();title='';dialogVisible=false">取消</el-button>
        <el-button type="primary" :loading="buttonLoading" @click="confirm()">确定</el-button>
      </el-row>
    </el-dialog>

    <el-dialog title="批量新增" top="20px" width="500px" :visible.sync="dialogVisibleBatch"> 
      <el-form :model="formBatch" ref="formBatch" label-width="auto">
        <el-form-item label="上传文件：" required="">
          <el-upload
            class="upload-demo"
             action="" :http-request="importExcel" :show-file-list="false">
            <el-button v-if="!formBatch.file" size="small" type="primary">点击上传</el-button>
            <span v-if="formBatch.file">{{ formBatch.file.name }}</span>
            <el-button v-if="formBatch.file" size="small" type="primary" style="margin-left: 5px;">重新上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div style="font-size: 12px;padding-left: 80px;color: #4200ff;cursor: pointer;" @click="exportExcel">下载模板</div>
      <el-row class="text-right mt-20">
        <el-button @click="formBatch.file='';dialogVisibleBatch=false">取消</el-button>
        <el-button type="primary" :loading="buttonLoading" @click="confirmBatch()">确定</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
 
<script>
import { update } from 'lodash';

  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
 
  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    //ComponentName和文件名保持一致
    name:'netBarAccountManage',
    data() {
      //这里存放数据
      return {
        params:{
          netBarName:'',
          netBarAccount:'',
          pageNum:1,
          pageSize:20
        },
        total:0,
        tableData:[],
        title:'',
        form:{
          netBarId:null,
          netBarAccount:'',
          netBarName:'',
          netBarSource:'',
          matiBarAccount:'',
          barIp:'',
          barMac:'',
          isDeleted: 0
        },
        rules:{
          netBarAccount:[{ required: true, message: "请输入网关账号", trigger: "blur" }],
          netBarName:[{ required: true, message: "请输入网关名称", trigger: "blur" }],
          netBarSource:[{ required: true, message: "请输入网关来源", trigger: "blur" }],
          matiBarAccount:[{ required: true, message: "请输入马蹄ID", trigger: "blur" }],
          barIp:[{ required: true, message: "请输入网吧公网IP", trigger: "blur" }],
          barMac:[{ required: true, message: "请输入网吧mac", trigger: "blur" }],
        },
        dialogVisible:false,
        buttonLoading:false,
        dialogVisibleBatch: false,
        formBatch:{
          file:'',
        },
      };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      /**获取列表数据 */
      getTableList(){
        this.ajax.fetch({
          url: this.apis.netBarAccountManage.get,
          disableLoading: true,
          method: 'post',
          param: this.params,
          successFunc: res=>{
            this.total = res.total;
            this.tableData = res.result;
          },
          errorFunc: err=>{
            this.$message.error(err.info);
          }
        });
      },
      importExcel(file) {
        let index1 = file.file.name.lastIndexOf(".");
        let index2 = file.file.name.length;
        let postf = file.file.name.substring(index1, index2);//后缀名
        if (postf.indexOf('xlsx') === -1 && postf.indexOf('xls') === -1) {
          this.toast.showWarning('只能上传excel文件');
          return;
        }
        this.formBatch.file = file.file;
      },
      confirmBatch(){
        if(!this.formBatch.file) return this.$message.error('请选择文件');
        this.ajax.upload({
          url: this.apis.netBarAccountManage.import,
          param: this.formBatch,
          successFunc: res => {
            this.$message.success('导入成功');
            this.dialogVisibleBatch = false;
            this.formBatch.file = '';
            this.getTableList();
          },
          errorFunc: res => {
            this.toast.showWarning(res.info);
          }
        })
      },
      exportExcel(){
        this.ajax.downLoad(this.apis.netBarAccountManage.downLoad , {templateName:'netAccount'});
      },
      deleteFun(row){
        this.form.netBarId = row.netBarId;
        this.form.netBarAccount = row.netBarAccount;
        this.form.netBarName = row.netBarName;
        this.form.netBarSource = row.netBarSource;
        this.form.matiBarAccount = row.matiBarAccount;
        this.form.barIp = row.barIp;
        this.form.barMac = row.barMac;
        this.form.isDeleted = 1;
        let txt = '删除';
        this.$confirm(`确定${txt}该项?`, `确认${txt}`, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.ajax.fetch({
            url: this.apis.netBarAccountManage.update,
            disableLoading: true,
            method: 'post',
            param: this.form,
            successFunc: res=>{
              this.$message({
                type: 'success',
                message: `${txt}成功!`
              });
              this.resetForm();
              this.getTableList();
            },
            errorFunc: err=>{
              console.log(err);
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: `已取消${txt}`
          });    
          this.resetForm();      
        });
      },
      update(row){
        this.title = '编辑';
        this.form.netBarId = row.netBarId;
        this.form.netBarAccount = row.netBarAccount;
        this.form.netBarName = row.netBarName;
        this.form.netBarSource = row.netBarSource;
        this.form.matiBarAccount = row.matiBarAccount;
        this.form.barIp = row.barIp;
        this.form.barMac = row.barMac;
        this.dialogVisible = true;
      },
      /**确定 */
      confirm(){
        this.$refs["form"].validate((valid) => {
          if (valid) {
            if (this.form.netBarId == null) {
              this.ajax.fetch({
                url: this.apis.netBarAccountManage.add,
                disableLoading: true,
                method: 'post',
                param: this.form,
                successFunc: res=>{
                  this.$message.success('新增成功!');
                  this.dialogVisible = false;
                  this.resetForm();
                  this.getTableList();
                },
                errorFunc: err=>{
                  this.$message.error(err.info);
                }
              });
            }else{
              this.ajax.fetch({
                url: this.apis.netBarAccountManage.update,
                disableLoading: true,
                method: 'post',
                param: this.form,
                successFunc: res=>{
                  this.$message.success('编辑成功!');
                  this.dialogVisible = false;
                  this.resetForm();
                  this.getTableList();
                },
                errorFunc: err=>{
                  this.$message.error(err.info);
                }
              });
            }
          }
        });
      },
      resetForm(){
        this.form = {
          netBarId:null,
          netBarAccount:'',
          netBarName:'',
          netBarSource:'',
          matiBarAccount:'',
          barIp:'',
          barMac:'',
          isDeleted: ''
        }
      },
      resetParams(){
        this.params = {
          netBarName:'',
          netBarAccount:'',
          pageNum:1,
          pageSize:20
        }
      },
      handleSizeChange(page) {
        this.params.pageSize = page;
        this.getTableList();
      },
      handleCurrentChange(val){
        this.params.pageNum = val;
        this.getTableList();
      },
    },
    beforeCreate() {}, //生命周期 - 创建之前
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    beforeMount() {}, //生命周期 - 挂载之前
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.getTableList();
    },
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    deactivated() {}, //如果页面有keep-alive缓存功能，当组件被移除时，触发钩子函数deactivated
  }
</script>

<style lang='scss' scoped>

</style>


// WEBPACK FOOTER //
// src/page/netBarAccountManage/index.vue